import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconColor = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M16.022 15.624c.3 3.856 6.014 1.2 5.562 2.54-2.525 7.481-12.648 5.685-16.966 1.165C.451 15.081.461 8.276 4.64 4.04 8.868-.188 16.032-.495 19.928 4.018c7.632 8.84-4.17 8.165-3.906 11.606z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M7.19 14.83a1.52 1.52 0 100-3.041 1.52 1.52 0 000 3.04zM10.95 19.664a1.52 1.52 0 100-3.04 1.52 1.52 0 000 3.04zM14.586 7.432a1.52 1.52 0 100-3.04 1.52 1.52 0 000 3.04zM8.14 9.044a1.52 1.52 0 100-3.04 1.52 1.52 0 000 3.04z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconColor.displayName = "IconColor";

export { IconColor };
